export class VisitConfigurationModel {
  visitDisplayConfiguration: string;
  visitOrder: string;
  visitType: string;
}
